import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateDetailDay, selectGlobalDay } from '../store/graphs/actions'
import 'react-dropdown/style.css'
import autoBind from 'react-autobind'
import Graph from './Graph'
import {GRAPH_SIZE, PRODUCT_COLUMNS} from '../store/graphs/constants.js'
import './Row.css'
import * as graphSelectors from '../store/graphs/reducer'
import DayBar from '../components/DayBar'



class Row extends Component {

  constructor(props){
    super(props)
    this.state = {selectedDay: this.props.days[0]}
    autoBind(this)
  }

  componentDidUpdate(){
    if (this.state.selectedDay === undefined && this.props.days.length > 0){
      this.setState({selectedDay:this.props.days[0]})
    }
  }


   selectDay(day){
        this.props.dispatch(updateDetailDay(day.value))
        if(this.props.globalDay === null){
          this.setState({selectedDay:day.value})
        }else{
          this.props.dispatch(selectGlobalDay(day.value))
        }
    }

   render() {
    const selectedDay = this.props.globalDay !== null ? this.props.globalDay : this.state.selectedDay
      const row = PRODUCT_COLUMNS.map(column => {
        const id = `${this.props.rowID}_${column}`
        const selected = this.props.selectedGases.length === 0 || this.props.selectedGases.indexOf(column) > -1
        return selected && this.props.graphs.indexOf(id) > -1
          ? <Graph key={column} id={id} currentDay={selectedDay} rowIndex={this.props.rowIndex} size={GRAPH_SIZE}/>
          : <svg width={GRAPH_SIZE[0]} height={GRAPH_SIZE[1]} key={column} aria-hidden="true" />
      })

      const stationString = <div className="station-label">
                            <p className="station-name">{this.props.station.name}</p>
                            <p className="station-id">{this.props.station.typeName || ''}{this.props.station.id}</p>
                            </div>

      return(<div className="row measurement-grid">
              {stationString}
              <div className="chart-row product-grid">{row}</div>
              <DayBar days={this.props.days} allDays={this.props.allDays} globalDay={this.props.globalDay} />
              </div>)
   }
}

const mapStateToProps = (state, ownProps) => {
  const graphs = graphSelectors.getGraphs(state, ownProps.rowID)
  const selectedGases = graphSelectors.getSelectedGases(state)
  const days = graphSelectors.getDays(state, ownProps.rowID)
  const allDays = graphSelectors.getAllDays(state)
  const globalDay = graphSelectors.getGlobalDay(state)

  return {
    graphs: graphs,
    selectedGases: selectedGases,
    days: days,
    globalDay: globalDay,
    allDays: allDays
  }
}

export default connect(mapStateToProps)(Row)
